import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { PermissionsProvider } from "./PermissionsContext";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <PermissionsProvider>
    <React.Fragment>
      <App />
    </React.Fragment>
  </PermissionsProvider>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
// Back button effects removed to enforce consistent, static placement across pages
